/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTextMultiline from 'base/components/labrador/TextMultiline';

export const DynamicLabradorTextMultiline: typeof LabradorTextMultiline = (props) => {
    return <ErrorBoundary><LabradorTextMultiline {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTextMultilineProps = PropsFromComponent<typeof LabradorTextMultiline>;
